module.exports = __webpack_public_path__ + "static/media/gates.0dfa5ec7.png";